"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
require("rc-calendar/assets/index.css");
require("rc-time-picker/assets/index.css");
require("./DateTimeStyle.css");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var Picker_1 = __importDefault(require("rc-calendar/lib/Picker"));
var RangeCalendar_1 = __importDefault(require("rc-calendar/lib/RangeCalendar"));
var Panel_1 = __importDefault(require("rc-time-picker/lib/Panel"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var DateRangePickerContainer = styled_components_1.default.div.attrs({
    className: 'tws-daterange-picker-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t& > span {\n\t\tdisplay: inline-flex;\n\t\twidth: fit-content;\n\t\tcolor: ", ";\n\t}\n\t.tws-daterange-picker-input-start,\n\t.tws-daterange-picker-input-end {\n\t\twidth: 240px;\n\t\tmargin-right: 10px;\n\t\tpadding-right: 10px;\n\t}\n\t.tws-daterange-picker-button {\n\t\tbackground-color: ", " !important;\n\t\tborder-color: ", " !important;\n\t\t:hover {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t\t:not([disabled]):not(.disabled).active,\n\t\t:not([disabled]):not(.disabled):active {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t}\n"], ["\n\t& > span {\n\t\tdisplay: inline-flex;\n\t\twidth: fit-content;\n\t\tcolor: ", ";\n\t}\n\t.tws-daterange-picker-input-start,\n\t.tws-daterange-picker-input-end {\n\t\twidth: 240px;\n\t\tmargin-right: 10px;\n\t\tpadding-right: 10px;\n\t}\n\t.tws-daterange-picker-button {\n\t\tbackground-color: ", " !important;\n\t\tborder-color: ", " !important;\n\t\t:hover {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t\t:not([disabled]):not(.disabled).active,\n\t\t:not([disabled]):not(.disabled):active {\n\t\t\tbackground-color: #04667c !important;\n\t\t\tborder-color: #04667c !important;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.white, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.mainBlue);
var DateButton = (0, styled_components_1.default)(Common_1.Button).attrs({
    className: 'tws-daterange-picker-button',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t&.btn.btn-floating {\n\t\tdisplay: flex;\n\t\twidth: 60px;\n\t\tpadding: 0 12px;\n\t\tjustify-content: left;\n\t\t.date-icon {\n\t\t\tmargin: 0;\n\t\t}\n\t\t.date-caret {\n\t\t\tfont-size: 10px !important;\n\t\t\tmargin: 0 6px 0 8px;\n\t\t\twidth: auto !important;\n\t\t}\n\t}\n"], ["\n\t&.btn.btn-floating {\n\t\tdisplay: flex;\n\t\twidth: 60px;\n\t\tpadding: 0 12px;\n\t\tjustify-content: left;\n\t\t.date-icon {\n\t\t\tmargin: 0;\n\t\t}\n\t\t.date-caret {\n\t\t\tfont-size: 10px !important;\n\t\t\tmargin: 0 6px 0 8px;\n\t\t\twidth: auto !important;\n\t\t}\n\t}\n"])));
DateButton.displayName = 'DateButton';
var ClearButton = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", " !important;\n\tdisplay: block;\n\tfont-size: 12px;\n\tmargin-top: 5px;\n\ttext-decoration: underline;\n\twidth: fit-content;\n\t&:hover {\n\t\ttext-decoration: none;\n\t}\n\t&:not([href]):not([tabindex]) {\n\t\ttext-decoration: underline;\n\t}\n"], ["\n\tcolor: ", " !important;\n\tdisplay: block;\n\tfont-size: 12px;\n\tmargin-top: 5px;\n\ttext-decoration: underline;\n\twidth: fit-content;\n\t&:hover {\n\t\ttext-decoration: none;\n\t}\n\t&:not([href]):not([tabindex]) {\n\t\ttext-decoration: underline;\n\t}\n"])), globalVars_module_scss_1.default.mainBlue);
ClearButton.displayName = 'ClearButton';
var defaultFormat = 'MMM D, YYYY [at] h:mma (Z)';
function format(v) {
    return v ? v.format(defaultFormat) : '';
}
function isValidRange(v) {
    return v && v[0] && v[1];
}
var now = (0, moment_1.default)();
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.timePickerElement = (React.createElement(Panel_1.default, { defaultValue: [(0, moment_1.default)('00:00:00', 'HH:mm:ss'), (0, moment_1.default)('23:59:59', 'HH:mm:ss')], showMinute: _this.props.showMinute, showSecond: _this.props.showSecond, use12Hours: _this.props.use12Hours, format: 'h:mm a' }));
        _this.onChange = function (value) {
            var _a = _this.props, defaultGap = _a.defaultGap, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate, showMinute = _a.showMinute, showSecond = _a.showSecond;
            var selectedDates = _this.state.selectedDates;
            if (enabledStartDate || enabledEndDate) {
                var startDate = value[0];
                var endDate = value[1];
                // Check whether start date changed
                // No change to selectedDates state if selected date is earlier than enabledStartDate
                if (selectedDates && !startDate.isSame(selectedDates[0])) {
                    if (enabledStartDate && startDate.isBefore(enabledStartDate, 'day')) {
                        return;
                    }
                }
                // Check whether end date changed
                // No change to selectedDates state if selected date is later than enabledEndDate
                if (selectedDates && !endDate.isSame(selectedDates[1])) {
                    if (enabledEndDate && endDate.isAfter(enabledEndDate, 'day')) {
                        return;
                    }
                }
                if (enabledStartDate) {
                    // Set open Date to enabledStartDate
                    // if value[0] is on the same day of enabledStartDate and value[0] is earlier than enabledStartDate
                    if ((0, moment_1.default)(startDate).isSame(enabledStartDate, 'day') && (0, moment_1.default)(startDate).isSameOrBefore(enabledStartDate)) {
                        value[0] = (0, moment_1.default)(enabledStartDate).add(defaultGap, 'hour');
                    }
                    // Set close Date to be same as enabledStartDate
                    // if value[1] is on the same day of enabledStartDate and value[1] is earlier than value[0]
                    if (enabledStartDate && (0, moment_1.default)(endDate).isSame(enabledStartDate, 'day') && enabledStartDate.isAfter((0, moment_1.default)(endDate))) {
                        value[1] = (0, moment_1.default)(value[0]);
                    }
                }
                // Set close Date to enabledEndDate
                // if value[1] is on the same day of enabledEndDate and value[1] is later than enabledEndDate
                if (enabledEndDate) {
                    if ((0, moment_1.default)(endDate).isSame(enabledEndDate, 'day') && enabledEndDate.isBefore((0, moment_1.default)(endDate))) {
                        value[1] = (0, moment_1.default)(enabledEndDate);
                    }
                }
            }
            if (!showMinute) {
                value[0].set({ minute: 0 });
                value[1].set({ minute: 0 });
            }
            if (!showSecond) {
                value[0].set({ second: 0 });
                value[1].set({ second: 0 });
            }
            value[0].set({ millisecond: 0 });
            value[1].set({ millisecond: 0 });
            _this.setState({ selectedDates: value });
        };
        _this.onOpenChange = function (open) {
            if (!_this.props.enableInput) {
                if (open) {
                    // Delay to ensure the calendar input field has been rendered
                    setTimeout(function () {
                        var targetCalendarInputs = document.getElementsByClassName('rc-calendar-input');
                        if (targetCalendarInputs && targetCalendarInputs.length > 0) {
                            lodash_1.default.each(targetCalendarInputs, function (input) {
                                input.setAttribute('readonly', 'readonly');
                            });
                        }
                    }, 500);
                }
            }
        };
        _this.onHoverChange = function (hoverValue) {
            _this.setState({ hoverDate: hoverValue });
        };
        _this.disableTime = function (time, type) {
            var _a = _this.props, defaultGap = _a.defaultGap, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate;
            // For range start date
            if (type === 'start' && enabledStartDate) {
                return {
                    disabledHours: function () {
                        if (enabledStartDate.isSame((0, moment_1.default)(time[0]), 'day')) {
                            var enabledStartDateHour = (0, moment_1.default)(enabledStartDate).hours();
                            if (enabledStartDateHour !== 0) {
                                return lodash_1.default.range(0, enabledStartDateHour + defaultGap);
                            }
                        }
                        if ((0, moment_1.default)(time[0]).isBefore(enabledStartDate, 'day')) {
                            return lodash_1.default.range(0, 24);
                        }
                        return undefined;
                    },
                };
            }
            // For range end date
            if (type === 'end' && enabledEndDate) {
                return {
                    disabledHours: function () {
                        if (enabledEndDate.isSame((0, moment_1.default)(time[1]), 'day')) {
                            var enabledEndDateHour = (0, moment_1.default)(enabledEndDate).hours();
                            if (enabledEndDateHour !== 0) {
                                return lodash_1.default.range(enabledEndDateHour + 1, 24);
                            }
                        }
                        if ((0, moment_1.default)(time[1]).isAfter(enabledEndDate, 'day')) {
                            return lodash_1.default.range(0, 24);
                        }
                        return undefined;
                    },
                };
            }
            return {};
        };
        _this.handleOnOpen = function () {
            var _a = _this.props, defaultGap = _a.defaultGap, defaultHour = _a.defaultHour, showMinute = _a.showMinute, showSecond = _a.showSecond;
            var originalDates = _this.state.originalDates;
            var date = new Date();
            var isSetEnabledStartDate = false;
            if (defaultHour !== undefined) {
                date.setHours(defaultHour);
            }
            if (_this.props.enabledStartDate) {
                if (_this.props.enabledStartDate && (0, moment_1.default)(date).isSame(_this.props.enabledStartDate, 'day')) {
                    isSetEnabledStartDate = true;
                    date = _this.props.enabledStartDate.toDate();
                }
            }
            if (!showMinute) {
                date.setMinutes(0);
            }
            if (!showSecond) {
                date.setSeconds(0);
            }
            date.setMilliseconds(0);
            var originalSelectedDates = originalDates ||
                (isSetEnabledStartDate
                    ? [(0, moment_1.default)(date).add(defaultGap, 'hour'), (0, moment_1.default)(date).add(defaultGap, 'hour')]
                    : [(0, moment_1.default)(date), (0, moment_1.default)(date)]);
            _this.setState({ selectedDates: originalSelectedDates, open: true });
        };
        _this.handleOnApply = function () {
            var onChange = _this.props.onChange;
            var selectedDates = _this.state.selectedDates;
            var originalDates = selectedDates;
            _this.setState({ originalDates: originalDates, open: false }, function () {
                if (onChange) {
                    onChange(selectedDates);
                }
            });
        };
        _this.handleOnClear = function () {
            var onClear = _this.props.onClear;
            _this.setState({ originalDates: undefined, open: false }, function () {
                if (onClear) {
                    onClear();
                }
            });
        };
        var value = _this.props.value;
        var dates;
        if (value && value.length === 2) {
            dates = [(0, moment_1.default)(value[0]), (0, moment_1.default)(value[1])];
        }
        _this.state = {
            selectedDates: [(0, moment_1.default)(new Date()), (0, moment_1.default)(new Date())],
            originalDates: dates,
            hoverDate: [],
            open: false,
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onOpenChange = _this.onOpenChange.bind(_this);
        _this.onHoverChange = _this.onHoverChange.bind(_this);
        _this.handleOnApply = _this.handleOnApply.bind(_this);
        _this.handleOnOpen = _this.handleOnOpen.bind(_this);
        _this.handleOnClear = _this.handleOnClear.bind(_this);
        _this.disabledDate = _this.disabledDate.bind(_this);
        return _this;
    }
    DateRangePicker.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        var dates;
        if (value && value.length === 2) {
            dates = [(0, moment_1.default)(value[0]), (0, moment_1.default)(value[1])];
        }
        this.setState({ originalDates: dates });
    };
    DateRangePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.applyButtonText, applyButtonText = _b === void 0 ? 'Apply' : _b, _c = _a.clearText, clearText = _c === void 0 ? 'Clear' : _c, _d = _a.dateFormat, dateFormat = _d === void 0 ? defaultFormat : _d;
        var _e = this.state, originalDates = _e.originalDates, selectedDates = _e.selectedDates, hoverDate = _e.hoverDate;
        var calendarRender = (React.createElement(RangeCalendar_1.default, { className: 'tws-calendar tws-daterange-picker', defaultValue: [now, now.clone().add(1, 'months')], format: dateFormat, dateInputPlaceholder: [this.props.dateInputStartPlaceholder, this.props.dateInputEndPlaceholder], disabledDate: this.disabledDate, showToday: false, showOk: false, hoverValue: hoverDate, disabledTime: this.disableTime, onHoverChange: this.onHoverChange, showClear: true, timePicker: this.props.showTime ? this.timePickerElement : null, renderFooter: function () {
                return _this.props.showTime ? (React.createElement(Common_1.Button, { id: 'applyButton', color: 'primary', size: 'sm', onClick: _this.handleOnApply }, applyButtonText)) : null;
            }, renderSidebar: function () {
                return _this.props.headerStartLabel && _this.props.headerEndLabel ? (React.createElement("div", { className: 'tws-calendar-header' },
                    React.createElement("div", { className: 'tws-calendar-header-start-label' }, _this.props.headerStartLabel),
                    React.createElement("div", { className: 'tws-calendar-header-end-label' }, _this.props.headerEndLabel))) : null;
            }, onClear: this.handleOnClear }));
        return (React.createElement(DateRangePickerContainer, null,
            React.createElement(Picker_1.default, { placement: this.props.placement, value: selectedDates, onChange: this.onChange, onOpenChange: this.onOpenChange, animation: 'slide-up', calendar: calendarRender }, function (_a) {
                var value = _a.value;
                return (React.createElement("span", { tabIndex: 0 },
                    React.createElement(Common_1.TwsInput, __assign({}, _this.props, { value: originalDates ? (isValidRange(originalDates) && "".concat(format(originalDates[0]))) || '' : '', className: 'tws-daterange-picker-input-start', placeholder: _this.props.textInputStartPlaceholder, onFocus: _this.handleOnOpen, onChange: function () {
                            /* */
                        } })),
                    React.createElement(Common_1.TwsInput, __assign({}, _this.props, { value: originalDates ? (isValidRange(originalDates) && "".concat(format(originalDates[1]))) || '' : '', className: 'tws-daterange-picker-input-end', placeholder: _this.props.textInputEndPlaceholder, onFocus: _this.handleOnOpen, onChange: function () {
                            /* */
                        } })),
                    React.createElement(DateButton, { onClick: _this.handleOnOpen, floating: true, color: 'primary' },
                        React.createElement(Common_1.Icon, { name: 'calendar', className: 'date-icon' }),
                        React.createElement(Common_1.Icon, { name: 'angle-down', className: 'date-caret' }))));
            }),
            this.props.showClear && React.createElement(ClearButton, { onClick: this.handleOnClear }, clearText),
            this.getExtraMessage()));
    };
    DateRangePicker.prototype.getExtraMessage = function () {
        if (this.props.error) {
            return Common_1.MessageHelper.getFormattedErrorMessages(this.props.message);
        }
        if (this.props.success) {
            return Common_1.MessageHelper.getFormattedSuccessMessages(this.props.message);
        }
        return null;
    };
    DateRangePicker.prototype.disabledDate = function (current) {
        if (!current) {
            // allow empty select
            return false;
        }
        var _a = this.props, enabledStartDate = _a.enabledStartDate, enabledEndDate = _a.enabledEndDate;
        var currentClone = lodash_1.default.cloneDeep(current);
        var startOfCurrentDay = currentClone.startOf('day');
        if (enabledStartDate && enabledEndDate) {
            return startOfCurrentDay.isBefore(enabledStartDate, 'day') || startOfCurrentDay.isAfter(enabledEndDate, 'day');
        }
        else if (enabledStartDate) {
            return startOfCurrentDay.isBefore(enabledStartDate, 'day');
        }
        else if (enabledEndDate) {
            return startOfCurrentDay.isAfter(enabledEndDate, 'day');
        }
        return false;
    };
    // Default props
    DateRangePicker.defaultProps = {
        defaultGap: 0,
        use12Hours: true,
        showClear: true,
        showTime: true,
        showMinute: true,
        showSecond: false,
        dateInputStartPlaceholder: 'Start date',
        dateInputEndPlaceholder: 'End date',
        textInputStartPlaceholder: 'No start date',
        textInputEndPlaceholder: 'No end date',
        placement: 'bottomLeft',
        enableInput: true,
    };
    return DateRangePicker;
}(React.Component));
exports.DateRangePicker = DateRangePicker;
var templateObject_1, templateObject_2, templateObject_3;
